<header>
  <p class="header-tittle">Contanos sobre tu negocio</p>
</header>
<app-navigation [currentStep]="1" [countSteppers]="7"></app-navigation>

<!-- Body -->
<form [formGroup]="customerForm" class="layout-form" (ngSubmit)="onSubmit()">
  <div class="component-content">
    <div class="header-text-container">
      <span class="header-text">Queremos conocer tu comercio. <br>
        Esto nos ayuda a ofrecerte lo mejor.</span>
    </div>
    <div>
      <div class="customer-input-container">
        <app-text-input
          id="business-name-input"
          [attr.data-testid]="'nombre-fantansia'"
          [labelText]="'Nombre del negocio'"
          [type]="'text'"
          [placeholder]="'Ejemplo: Panadería San Martin'"
          [required]="true"
          formControlName="fantasyName"
          [submitted]="submitted"
        ></app-text-input>
      </div>
      <div [ngClass]="{ 'form-map': true, 'warning-label': submitted && !customerForm.get('location')?.valid }">
        <app-map
          #mapRef
          formControlName="location"
          [required]="true"
          [submitted]="submitted"
        ></app-map>
      </div>
    </div>
  </div>
</form>
<!-- Footer -->

<div class="button-container">
  <button id="continue-button" mat-raised-button class="next-button" type="submit" (click)="onSubmit()">Continuar</button>
</div>
